import { Box } from '@mui/material';
import Map from 'components/Map';
import { useMapState } from 'state/useMapState';
import { RefObject } from 'react';
import { DrawerRefContent } from 'components/Map/MapEntityDrawer';
import { Capacitor } from '@capacitor/core';
import { ProgressionModelLayer } from '../ProgressionModelLayer';

type ProgressionModelMapProps = {
  modelId: number;
  drawerRef: RefObject<DrawerRefContent | null>;
};

export const ProgressionModelMap = (
  props: ProgressionModelMapProps,
): JSX.Element => {
  const { modelId, drawerRef } = props;
  const { incidentMapState } = useMapState();

  const center = {
    lat: incidentMapState.center.lat,
    lng: incidentMapState.center.lng,
  };

  const isMobileApp = Capacitor.isNativePlatform();

  return (
    <Box sx={{ flex: 1, display: 'flex' }}>
      <Box
        sx={{ flexGrow: 1, position: 'relative' }}
        onMouseDown={
          isMobileApp ? undefined : () => drawerRef.current?.minimize()
        }
        onTouchStart={
          isMobileApp ? () => drawerRef.current?.minimize() : undefined
        }
      >
        <Map center={center} zoom={10}>
          <ProgressionModelLayer visible modelId={modelId} />
        </Map>
      </Box>
    </Box>
  );
};
